import { jsx as _jsx } from "react/jsx-runtime";
// Build the option list once at module load — same shape on every render.
const OPTIONS = (() => {
    const list = [];
    for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 15) {
            const hh = String(h).padStart(2, "0");
            const mm = String(m).padStart(2, "0");
            const value = `${hh}:${mm}`;
            // Pretty AM/PM label so users don't have to mentally convert 14:30.
            const period = h < 12 ? "AM" : "PM";
            const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
            const label = `${h12}:${mm} ${period}`;
            list.push({ value, label });
        }
    }
    return list;
})();
// Normalize an incoming HH:MM or HH:MM:SS to HH:MM so the <select>'s value
// matches one of the option keys (otherwise the dropdown shows blank).
function normalize(v) {
    if (!v)
        return "09:00";
    const parts = v.split(":");
    const h = parts[0]?.padStart(2, "0") ?? "09";
    const m = parts[1]?.padStart(2, "0") ?? "00";
    // Snap odd minutes down to the nearest 15 so legacy data displays in the
    // dropdown (e.g. "09:07" → "09:00"). Caller can still pass a clean value.
    const mNum = Math.floor(Number(m) / 15) * 15;
    return `${h}:${String(mNum).padStart(2, "0")}`;
}
export default function TimeSelect({ value, onChange, disabled, required, id, name, }) {
    return (_jsx("select", { id: id, name: name, value: normalize(value), onChange: (e) => onChange(e.target.value), disabled: disabled, required: required, children: OPTIONS.map((o) => (_jsx("option", { value: o.value, children: o.label }, o.value))) }));
}
